var module = angular.module('octopusApp.configuration');

module.controller('TeamAddDomainGroupDialogController', function($scope, busy, $uibModalInstance, octopusRepository, lookupUri) {
  var isLoading = $scope.isLoading = busy.create();

  $scope.results = null;
  $scope.adding = { members: [] };

  $scope.search = {
    groupName: "",

    hasSearched: false,

    perform: function() {
      isLoading.promise(octopusRepository.ExternalSecurityGroups.search(lookupUri, $scope.search.groupName).then(function (results) {
        $scope.results = results;
        $scope.hasSearched = true;
      }));
    }
  };

  $scope.close = function() {
    $uibModalInstance.close();
  };

  $scope.save = function () {
    $uibModalInstance.close(_.filter($scope.results, function (r) { return r.Selected; }));
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/teams/controllers/team_add_domain_group_dialog_controller.js
// module id = 400
// module chunks = 1